import React from 'react'
const Home = React.lazy(() => import('../pages/Home'))
const sampleMaps = React.lazy(() => import('../pages/SampleReport'))
const innerPages = React.lazy(() => import('../pages/InnerPages'))
const Faqs = React.lazy(() => import('../pages/Faqs'))
const RecentPosts = React.lazy(() => import('../pages/RecentPosts'))
const Feedback = React.lazy(() => import('../pages/Feedback'))
const PodCasts = React.lazy(() => import('../pages/Podcasts'))
const Login = React.lazy(() => import('../pages/Login'))
const ContactUS = React.lazy(() => import('../pages/ContactUs'))
const AttorneyDashboard = React.lazy(() => import('../pages/AttorneyDashboard'))
const clientRegister = React.lazy(() => import('../pages/ClientRegister'))
const attAlliedRegister = React.lazy(() => import('../pages/AttAlliedRegister'))
const AttorneySignupQuestion = React.lazy(() => import('../pages/AttorneySignupQuestion'))
const forClient = React.lazy(() => import('../pages/ForClient'))
const forAttorney = React.lazy(() => import('../pages/ForAttorney'))
const forFamily = React.lazy(() => import('../pages/ForFamily'))
const forProfessionals = React.lazy(() => import('../pages/ForProfessionals'))
const ResetPassword = React.lazy(() => import('../pages/ResetPassword'))
const ForgotUsernamePwd = React.lazy(() => import('../pages/ForgotUsernamePwd'))
const FaceSheet = React.lazy(() => import('../pages/FaceSheet'))
const Intake = React.lazy(() => import('../pages/Intake'))
const Presection = React.lazy(() => import('../pages/Presection'))
const EditClientProfile = React.lazy(() => import('../pages/EditClientProfile'))
const HowItWorks = React.lazy(() => import('../pages/HowItWorks'))
const SayMoreReview = React.lazy(() => import('../pages/SayMoreReview'))
const Conclusion = React.lazy(() => import('../pages/Conclusion'))
const SubmitIntake = React.lazy(() => import('../pages/SubmitIntake'))
const AccountDeletion = React.lazy(() => import('../pages/AccountDeletion'))
const AccountDeleted = React.lazy(() => import('../pages/AccountDeleted'))
const ChangePassword = React.lazy(() => import('src/components/layouts/attorney/ChangePassword'))
const SubmittedIntake = React.lazy(() => import('../pages/SubmittedIntake'))
const Messages = React.lazy(() => import('../pages/Messages'))
const unsubscribe = React.lazy(() => import('../pages/Unsubscribe'))
const AdminDashboard = React.lazy(() => import('../pages/AdminDashboard'))
const Voices = React.lazy(() => import('../pages/Voices'))
const homeRoutes = [
  { path: '/', exact: true, name: 'Home', element: Home },
  { path: '/index', exact: true, name: 'Home', element: Home },
  { path: '/samplereports', exact: true, name: 'SampleMap', element: sampleMaps },
  { path: '/about', exact: true, name: 'aboutUs', element: innerPages },
  { path: '/termsofuse', exact: true, name: 'termsofuse', element: innerPages },
  { path: '/privacypolicy', exact: true, name: 'privacypolicy', element: innerPages },
  { path: '/ourmission', exact: true, name: 'ourMission', element: innerPages },
  { path: '/whoweare', exact: true, name: 'whoWeAre', element: innerPages },
  // { path: '/advisoryboard', exact: true, name: 'advisoryBoard', element: innerPages },
  { path: '/tocindy', exact: true, name: 'toCindy', element: innerPages },
  { path: '/contact', exact: true, name: 'contact', element: innerPages },
  { path: '/faqs', exact: true, name: 'Faqs', element: Faqs },
  { path: '/posts', exact: true, name: 'RecentPosts', element: RecentPosts },
  { path: '/feedback', exact: true, name: 'Feedback', element: Feedback },
  { path: '/podcasts', exact: true, name: 'PodCasts', element: PodCasts },
  { path: '/contactus', exact: true, name: 'ContactUs', element: ContactUS },
  { path: '/login', exact: true, name: 'Login', element: Login },
  { path: '/registerclient', exact: true, name: 'registerClient', element: clientRegister },
  { path: '/registerattorney', exact: true, name: 'attAlliedRegister', element: attAlliedRegister },
  {
    path: '/registeralliedprofessional',
    exact: true,
    name: 'attAlliedRegister',
    element: attAlliedRegister,
  },
  { path: '/forclients', exact: true, name: 'forclients', element: forClient },
  { path: '/forattorney', exact: true, name: 'forAttorney', element: forAttorney },
  { path: '/forprofessionals', exact: true, name: 'forProfessionals', element: forProfessionals },
  { path: '/forfamily', exact: true, name: 'forFamily', element: forFamily },
  { path: '/resetpassword', exact: true, name: 'ResetPassword', element: ResetPassword },
  {
    path: '/forgotusernamepassword',
    exact: true,
    name: 'ForgotUsernamePwd',
    element: ForgotUsernamePwd,
  },
  { path: '/howitworks', exact: true, name: ' HowItWorks ', element: HowItWorks },
  { path: '/accountdeleted', exact: true, name: ' AccountDeleted ', element: AccountDeleted },
  { path: '/unsubscriberemainder', exact: true, name: ' AccountDeleted ', element: unsubscribe },
  { path: '/voices', exact: true, name: 'Voices', element: Voices },
]

const attorneyRoutes = [
  { path: '/', exact: true, name: 'AttorneyAccount', element: AttorneyDashboard },
  { path: '/podcasts', exact: true, name: 'AttorneyAccount', element: AttorneyDashboard },
  { path: '/editprofile', exact: true, name: 'AttorneyAccount', element: AttorneyDashboard },
  { path: '/editalliedprofile', exact: true, name: 'AttorneyAccount', element: AttorneyDashboard },
  { path: '/inviteclient', exact: true, name: 'AttorneyAccount', element: AttorneyDashboard },
  { path: '/uploadmap', exact: true, name: 'AttorneyAccount', element: AttorneyDashboard },
  { path: '/changepassword', exact: true, name: 'AttorneyAccount', element: AttorneyDashboard },
  { path: '/changeusername', exact: true, name: 'AttorneyAccount', element: AttorneyDashboard },
  { path: '/pendingreferrals', exact: true, name: 'AttorneyAccount', element: AttorneyDashboard },
  { path: '/deleteaccount', exact: true, name: 'AttorneyAccount', element: AttorneyDashboard },
  { path: '/alliedinvite', exact: true, name: 'AttorneyAccount', element: AttorneyDashboard },
  {
    path: '/addmaptoattorney',
    exact: true,
    name: 'AttorneyAccount',
    element: AttorneyDashboard,
  },
  {
    path: '/attorneysignup2',
    exact: true,
    name: 'AttorneySignupQuestion',
    element: AttorneySignupQuestion,
  },
  {
    path: '/weeklystatusemailsubscription',
    exact: true,
    name: 'AttorneySignupQuestion',
    element: AttorneyDashboard,
  },
]

const clientRoutes = [
  { path: '/facesheet/:page', exact: true, name: 'FaceSheet', element: FaceSheet },
  { path: '/intake/:page', exact: true, name: 'Intake', element: Intake },
  { path: '/presection/:page', exact: true, name: 'Presection', element: Presection },
  { path: '/changepassword', exact: true, name: 'ChangePassword', element: ChangePassword },
  { path: '/editprofile', exact: true, name: 'EditClientProfile', element: EditClientProfile },
  { path: '/reviewsaymorequestions', exact: true, name: 'SayMoreReview', element: SayMoreReview },
  { path: '/conclusion', exact: true, name: 'Conclusion', element: Conclusion },
  { path: '/deleteintake', exact: true, name: 'DeleteMap', element: AccountDeletion },
  { path: '/messages', exact: true, name: 'Messages', element: Messages },
  {
    path: '/submitintake',
    exact: true,
    name: 'SubmitIntake',
    element: SubmitIntake,
  },
  {
    path: '/submittedintakes',
    exact: true,
    name: 'SubmittedIntake',
    element: SubmittedIntake,
  },
]

const adminRoutes = [
  { path: '/', exact: true, name: 'Admin', element: AdminDashboard },
  { path: '/detentionips', exact: true, name: 'Admin', element: AdminDashboard },
  { path: '/approvedattorneys', exact: true, name: 'Admin', element: AdminDashboard },
]
export { homeRoutes, attorneyRoutes, clientRoutes, adminRoutes }
